import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateDefaultGJTypography,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  MuiFilledInput,
  styleRootCommonAppBar
} from "./util/theme-generator-util";

export const hotelviennaFontFamilyRegular = "Encode Sans";

export const hotelviennaThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#415f1e"
    },
    secondary: {
      main: "#DDB73C"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#EFEFEE",
      paper: "#f7f7f7"
    },
    text: {
      primary: "#282F31",
      secondary: "#282F31"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: generateDefaultGJTypography(hotelviennaFontFamilyRegular)
};
